import classnames from "classnames";
import { type FunctionComponent } from "react";

import CloseIcon from "nvent-web/assets/svg/delete.svg";

import style from "./DeleteIconButton.module.scss";

interface DeleteIconButtonProps {
  onDelete: () => void;
  className?: string;
}

const DeleteIconButton: FunctionComponent<DeleteIconButtonProps> = ({
  onDelete,
  className,
}) => {
  return (
    <button
      data-testid="delete"
      type="button"
      onClick={onDelete}
      className={classnames(style.button, className)}
    >
      <img src={CloseIcon} />
    </button>
  );
};

export default DeleteIconButton;
